import React, {useState, useEffect, useContext, useCallback} from 'react';
import styles from '../lock-screen/lock-screen.module.css';
import ArrowLeft from '../../assets/images/arrow_left.png';
import ArrowLeftActive from '../../assets/images/arrow_left_active.PNG';
import useKeyPress from '../../hooks/useKeyPress';
import classNames from 'classnames';
import {useMenu} from '../../hooks/useMenu';
import CommandsContext from '../../context/commandsContext';

const LEFT = 1;
const UP = 2;
const RIGHT = 3;
const DOWN = 4;
const defaultPattern = [LEFT, UP, DOWN, RIGHT];

function LockScreen({pattern = defaultPattern, onUnlock}) {
  const [pressed, setPressed] = useState([]);
  const rightPress = useKeyPress('ArrowRight');
  const leftPress = useKeyPress('ArrowLeft');
  const upPress = useKeyPress('ArrowUp');
  const downPress = useKeyPress('ArrowDown');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    setPressed([...pressed, LEFT]);
  }, [pressed]);

  const onRight = useCallback(() => {
    setPressed([...pressed, RIGHT]);
  }, [pressed]);

  const onUp = useCallback(() => {
    setPressed([...pressed, UP]);
  }, [pressed]);

  const onDown = useCallback(() => {
    setPressed([...pressed, DOWN]);
  }, [pressed]);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  useEffect(() => {
    if (!upPress) return;

    onUp();
  }, [upPress]);

  useEffect(() => {
    if (!downPress) return;
    onDown();
  }, [downPress]);

  useEffect(() => {
    const valid = pressed.every((key, i) => key === pattern[i]);

    if (!valid) {
      setPressed([]);
    } else if (pressed.length === 4) {
      onUnlock();
    }
  }, [pressed]);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft, onRight, onUp, onDown});
    });
  }, [onLeft, onRight, onUp, onDown]);

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <span className={styles.topText}>LOCKED</span>
      </div>
      <div className={styles.fullBody}>
        <div className={styles.captionContainer}>
          <span className={styles.caption}>
            Device is locked. Press buttons in the order shown to unlock.
          </span>
        </div>
        <div className={styles.buttonContainer}>
          <div className={classNames(styles.button, pressed[0] === LEFT && styles.buttonActive)}>
            <img
              className={classNames(styles.arrow, styles.left)}
              src={pressed[1] === LEFT ? ArrowLeftActive : ArrowLeft}
            />
            <div className={classNames(styles.number, pressed[0] === LEFT && styles.numberActive)}>
              1
            </div>
          </div>

          <div className={classNames(styles.button, pressed[1] === UP && styles.buttonActive)}>
            <img
              className={classNames(styles.arrow, styles.up)}
              src={pressed[2] === UP ? ArrowLeftActive : ArrowLeft}
            />
            <div className={classNames(styles.number, pressed[1] === UP && styles.numberActive)}>
              2
            </div>
          </div>

          <div className={classNames(styles.button, pressed[2] === DOWN && styles.buttonActive)}>
            <img
              className={classNames(styles.arrow, styles.down)}
              src={pressed[4] === DOWN ? ArrowLeftActive : ArrowLeft}
            />
            <div className={classNames(styles.number, pressed[2] === DOWN && styles.numberActive)}>
              3
            </div>
          </div>

          <div className={classNames(styles.button, pressed[3] === RIGHT && styles.buttonActive)}>
            <img
              className={classNames(styles.arrow, styles.right)}
              src={pressed[3] === RIGHT ? ArrowLeftActive : ArrowLeft}
            />
            <div className={classNames(styles.number, pressed[3] === RIGHT && styles.numberActive)}>
              4
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LockScreen;
